import * as React from "react";
import { Table, CustomButton, ButtonType, AlertMessage, AlertType } from "soprasteria-ui-library";
import { IPatientUnlistedNote } from "../../../../models/IPatientUnlisted";
import { dateTimeToDateString } from "../../../../helpers/DateHelper";
import { useAuth } from "../../../../App";
import { PatientUnlistedNoteApi } from "../../../../api/PatientUnlistedNoteApi";
import { setMessage } from "../../../../helpers/MessageHelper";
import { UnlistedNotesTabEditModal } from "../Modals/UnlistedNotesTabEditModal";

interface IUnlistedNotesTab {
    pnr: string;
    patientId: number;
    isInRoleAllmantandvard: boolean;
    isInRoleParaply: boolean;
}

export const UnlistedNotesTab: React.FunctionComponent<IUnlistedNotesTab> = ({ patientId, isInRoleAllmantandvard, isInRoleParaply, pnr }) => {

    const auth = useAuth();
    const api = new PatientUnlistedNoteApi(auth);

    const [notes, setNotes] = React.useState<IPatientUnlistedNote[]>([]);
    const [noteToEdit, setNoteToEdit] = React.useState<IPatientUnlistedNote>();
    const [successMessage, setSuccessMessage] = React.useState<string>("");
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [renderModal, setRenderModal] = React.useState<boolean>(false);

    React.useEffect(() => {
        getNotes();
    }, [pnr]);

    const getNotes = () => {
        api.getNotes(patientId, (data: IPatientUnlistedNote[]) => {
            setNotes(data);
        }, (message: string) => {
            const newErrorMessage = setMessage(message, errorMessage);
            setErrorMessage(newErrorMessage);
        });
    }

    const getNote = (patientUnlistedNoteId: number) => {
        api.getNote(patientUnlistedNoteId, (note: IPatientUnlistedNote) => {
            setRenderModal(true);
            setNoteToEdit(note);
        }, (message) => {
            const newErrorMessage = setMessage(message, errorMessage);
            setErrorMessage(newErrorMessage);
        });
    }

    const onSubmitedNoteSuccess = () => {
        closeModal();
        const message = setMessage("Noteringen har sparats", successMessage ?? "");
        setSuccessMessage(message);
        getNotes();
    }

    const onClickedNote = (noteId: number) => {
        setRenderModal(true);
        getNote(noteId);
    }

    const closeModal = () => {
        setRenderModal(false);
        setNoteToEdit(undefined);
    }

    return (
        <section>
            {
                renderModal ?
                    <UnlistedNotesTabEditModal
                        onSubmitSuccess={onSubmitedNoteSuccess}
                        patientId={patientId}
                        noteToEdit={noteToEdit}
                        onCloseModal={closeModal}
                        isInRoleParaply={isInRoleParaply}
                        isInRoleAllmantandvard={isInRoleAllmantandvard}
                    />
                    : null
            }
            <AlertMessage alertType={AlertType.success}>{successMessage}</AlertMessage>
            <AlertMessage alertType={AlertType.danger}>{errorMessage}</AlertMessage>
            {
                isInRoleAllmantandvard && !isInRoleParaply ?
                    <div className="panel text-right">
                        <CustomButton buttonType={ButtonType.create} buttonText="Skapa notering" data-toggle="modal" data-target="#note-modal" onClick={() => setRenderModal(true)} />
                    </div>
                    : null
            }
            <Table hoverableRows>
                <thead>
                    <tr>
                        <th>Notering</th>
                        <th>Datum</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        notes.length > 0
                            ? notes.map((note, key) => {
                                return (
                                    <tr key={key} className="clickable-row" onClick={() => onClickedNote(note.patientUnlistedNoteId)}>
                                        <td style={{ whiteSpace: "pre-wrap" }}>{note.contactedNote}</td>
                                        <td style={{ whiteSpace: "nowrap" }}>{dateTimeToDateString(note.noteDate)}</td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan={2}>Det finns inga noteringar på denna patient</td></tr>
                    }
                </tbody>
            </Table>
        </section>
    );
}